
  import * as fabIcons from './classic/brands.mjs';

  

  

  import * as fausbIcons from './utility/semibold.mjs';


var byPrefixAndName = {'fab': {},'fausb': {},};
var all = [];

function addIcons (icons) {
  Object.keys(icons).forEach(function (iconName) {
    if (iconName === 'prefix') {
      return;
    }

    var icon = icons[iconName];
    var aliases = icon.icon[2];
    aliases.forEach(function (alias) {
      if (typeof alias === 'string') {
        byPrefixAndName[icon.prefix][alias] = icon;
      }
    })
    byPrefixAndName[icon.prefix][icon.iconName] = icon;
    all.push(icon);
  });
}


  
  addIcons(fabIcons);
  var fab = fabIcons;
  

  

  

  
  addIcons(fausbIcons);
  var fausb = fausbIcons;
  


export {
  byPrefixAndName, all
  , fab, fausb
}
